import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "page_header" }
const _hoisted_2 = { class: "formContainer" }
const _hoisted_3 = {
  filter: "lineNumber",
  sort: "lineNumber"
}
const _hoisted_4 = {
  filter: "fabricCode",
  sort: "fabricCode"
}
const _hoisted_5 = {
  filter: "shortDescription",
  sort: "shortDescription"
}
const _hoisted_6 = {
  filter: "grams",
  sort: "grams"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { colspan: "10" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "mb-1" }
const _hoisted_14 = { class: "d-flex align-items-center" }
const _hoisted_15 = { class: "d-block text-nowrap me-1" }
const _hoisted_16 = {
  key: 0,
  class: "me-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_op_table = _resolveComponent("op-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_localized_text, {
        type: 'h1',
        localizedKey: "Your fabric compositions",
        text: "Your fabric compositions",
        class: "mb-0"
      }),
      (!_ctx.isReadOnly)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "btn btn-primary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.uploadExcelModal()))
          }, [
            _createVNode(_component_localized_text, {
              localizedKey: "Upload Excel",
              text: "Upload Excel"
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_op_table, {
        class: "table table-striped",
        items: _ctx.fabricCompositions
      }, {
        default: _withCtx((opData) => [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_3, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Line",
                  text: "Line"
                })
              ]),
              _createElementVNode("td", _hoisted_4, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Fabric Code",
                  text: "Fabric Code"
                })
              ]),
              _createElementVNode("td", _hoisted_5, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Short Description",
                  text: "Short Description"
                })
              ]),
              _createElementVNode("td", _hoisted_6, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Grams",
                  text: "Grams"
                })
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Composition",
                  text: "Composition"
                })
              ])
            ])
          ]),
          _createElementVNode("tbody", null, [
            (opData.data.length == 0)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_7, [
                  _createElementVNode("td", _hoisted_8, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "No Elements Found",
                      text: "No Elements Found"
                    })
                  ])
                ]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((opData.data as OM.CompanyFabricCompositions[]), (item, i) => {
              return (_openBlock(), _createElementBlock("tr", { key: i }, [
                _createElementVNode("td", null, [
                  _createElementVNode("span", null, _toDisplayString(item.lineNumber), 1)
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("span", null, _toDisplayString(item.fabricCode), 1)
                ]),
                _createElementVNode("td", null, [
                  (item.shortDescription)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(item.shortDescription), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_10, "--"))
                ]),
                _createElementVNode("td", null, [
                  (item.grams)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(item.grams), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_12, "--"))
                ]),
                _createElementVNode("td", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.fabricLayers, (fabric, index) => {
                    return (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        (item.fabricLayers.length > 1)
                          ? (_openBlock(), _createBlock(_component_localized_text, {
                              key: 0,
                              localizedKey: "Fabric:",
                              text: "Fabric:",
                              class: "me-1"
                            }))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fabric.percentageCompositionMaterials, (composition, compoIndx) => {
                          return (_openBlock(), _createElementBlock("span", _hoisted_15, [
                            (compoIndx > 0)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_16, "-"))
                              : _createCommentVNode("", true),
                            _createTextVNode(_toDisplayString(composition.percentage) + "% " + _toDisplayString(composition.material.text), 1)
                          ]))
                        }), 256))
                      ])
                    ]))
                  }), 256))
                ])
              ]))
            }), 128))
          ])
        ]),
        _: 1
      }, 8, ["items"])
    ])
  ], 64))
}